/* eslint-disable no-undef */
import React from 'react';
import { Flex, Heading, Image, Button } from 'rebass';
import styled from 'styled-components';
import ErrorMessage from 'components/ErrorMessage';
import Form from 'components/Form';
import Field from 'components/Field';
import arrowBackIcon from 'assets/icons/arrowBack.png';
import doneIcon from 'assets/icons/done.png';
import { useSelector } from 'react-redux';
import { startEditNotesSubmit, resolveEditSubmit } from './actions';
import ModalContent from '../ModalContent';

const Content = styled(ModalContent)`
  max-width: 420px;
  flex-direction: column;
`;

const FormButton = styled(Button)<any>`
  width: 100%;
  border-radius: 0;
  font-size: 20px;
  font-weight: 600;
  padding-top: 20px;
  padding-bottom: 20px;
  cursor: pointer;
  outline: none;
  opacity: ${props => (props.submitting ? '0.5' : '1')};
  cursor: ${props => (props.submitting ? 'wait' : 'pointer')};
`;

interface EditCandidatesNotesProps {
  closeModalHandler: VoidFunction;
}

const EditCandidatesNotes: React.FC<EditCandidatesNotesProps> = ({ closeModalHandler }) => {
  const { candidateId, noteId, note } = useSelector<any, any>(state => state.modal.data);
  const initialValue = { notes: note };

  return (
    <Content>
      <Flex width="100%" px={3} pt={4}>
        <Heading fontSize="30px" mb={2}>
          Recruiter Notes
        </Heading>
      </Flex>
      <Form
        startSubmitAction={startEditNotesSubmit().type}
        resolveSubmitAction={resolveEditSubmit().type}
        setPayload={(action: object, payload: any) => ({
          ...action,
          payload: {
            ...payload,
            noteId,
            candidateId,
          },
        })}
        initialValues={initialValue}
      >
        {(formProps: any) => {
          const { submitting, submitErrors } = formProps;
          return (
            <Flex flexDirection="column" alignItems="center">
              {submitErrors && <ErrorMessage>{submitErrors.data.error.message}</ErrorMessage>}
              <Flex px={3}>
                <Field
                  name="notes"
                  inputType="textarea"
                  placeholder="Type notes here…"
                  width="350px"
                  height="30vh"
                />
              </Flex>

              <Flex width="100%" flexDirection="column" mt={5}>
                <FormButton type="button" bg="#525252" onClick={closeModalHandler}>
                  <Flex justifyContent="center" alignItems="center">
                    <Image src={arrowBackIcon} mr={2} />
                    Back
                  </Flex>
                </FormButton>
                <FormButton type="submit" submitting={submitting} bg="lightGreen">
                  <Flex justifyContent="center" alignItems="center">
                    <Image src={doneIcon} mr={2} />
                    Done
                  </Flex>
                </FormButton>
              </Flex>
            </Flex>
          );
        }}
      </Form>
    </Content>
  );
};

export default EditCandidatesNotes;
